import {course_getCourses_Api} from 'apis'
import {createValue} from 'components/form/utils'
import React, {useMemo} from 'react'
import ContainerPicker, {renderDefaultActions,} from 'views/AppLocals/custom/ContainerPicker'
import {AppEntities} from 'views/AppLocals/enums'
import {bindQueryParams} from 'views/AppLocals/functions/routerHelper'
import {NullAsDefault} from 'views/Shared'
import {DoubleValueItem} from 'components/common/DoubleValueItem'
import {IdcodeTag} from 'components/common/IdcodeTag'
import {renderIf} from "../../../Shared";
import _ from 'lodash'
import {formatDate} from "../../../../helpers/datetimeHelpers";

export const CourseSelector = ({
                                   name,
                                   value,
                                   owner_id,
                                   owner_type,
                                   onChange = NullAsDefault,
                                   ...props
                               }) => {
    const defaultValue = value?.id ?? value

    const customConfigs = useMemo(() => ({
        apiInfo: course_getCourses_Api,
        query: bindQueryParams([{id: owner_id}, {type: owner_type}]),
    }), [owner_id, owner_type])

    const InnerWrapperCourse = ({children, ...props}) => (
        <div style={{ minHeight: 46 }} className="flex flex-col justify-center border border-color-100 background hover:background-50 rounded-lg">
            {children}
        </div>
    )

    return (
        <ContainerPicker
            name={name}
            allowClear={true}
            defaultValue={defaultValue}
            type={AppEntities.UNDEFINED}
            placeholder="click to select"
            renderInnerWrapper={InnerWrapperCourse}
            renderActions={renderDefaultActions(value)}
            renderOption={(o, i) => {

                const {title, course_idcode, time_open, time_close, last_enrollment_time} = o ?? {}

                return (
                    <div key={i} className="flex flex-col">
                        <span className="font-bold text-color-000 leading-6 flex items-center gap-1.5">
                            <IdcodeTag>{course_idcode}</IdcodeTag>
                            <span className="truncate">{title}</span>
                        </span>
                        {renderIf(
                            _.some([time_open, time_close]),
                            <DoubleValueItem
                                labelFirst="time"
                                valueFirst={formatDate(time_open, 'DD/MM/YYYY')}
                                labelSecond={time_close ? ' - ' : ''}
                                valueSecond={formatDate(time_close, 'DD/MM/YYYY')}
                                className="text-xs italic leading-tight"
                            />
                        )}

                    </div>
                )
            }}
            onOptionChange={(option) => {
                onChange(createValue(name, option ?? null))
            }}
            customConfigs={customConfigs}
            // disabled={true}
            {...props}
        />
    )
}
